import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { GainLossRowData, GainLossTableRenderer } from '../gain-loss-table-renderer';
import { AllocationsGainLossEnum } from '../../../../../../models/enums/allocations-gain-loss-enum';

export const UnrealizedCapitalTableContent: React.FC<{ type: AllocationsGainLossEnum }> = observer(({ type }) => {
    const { symbolPriceUpdateStore, statisticStore, portfolioStore } = useRootStore();
    const { ratiosStore } = statisticStore;

    const gainLossData = useMemo((): GainLossRowData[] => {
        const isGain = type === AllocationsGainLossEnum.Gain;

        const filteredData = ratiosStore.allUnrealizedAllocations.reduce<GainLossRowData[]>((acc, curr) => {
            if (curr.amount <= 0) {
                return acc;
            }

            const todayChange = symbolPriceUpdateStore.getTodayProfitBySymbolId(
                curr.referenceSymbolId ?? curr.symbolId,
                curr.value,
                curr.amount,
                curr.dateTo,
            );

            const profitValue = curr.profitValue + todayChange;
            const isMatch = isGain ? profitValue > 0 : profitValue < 0;

            if (isMatch) {
                const { invested } = curr;
                const profitPercentage = invested > 0 ? (profitValue / invested) * 100 : 0;

                acc.push({
                    ...curr,
                    profitValue,
                    profitPercentage,
                });
            }

            return acc;
        }, []);

        return filteredData
            .sort((a, b) => (isGain ? b.profitValue - a.profitValue : a.profitValue - b.profitValue))
            .slice(0, 5);
    }, [ratiosStore.allUnrealizedAllocations, symbolPriceUpdateStore, type]);

    return (
        <GainLossTableRenderer
            loading={ratiosStore.loading}
            isRecalculating={portfolioStore.selectedPortfolio.isRecalculating}
            gainLossData={gainLossData}
        />
    );
});
